import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft, FaChartBar } from "react-icons/fa";

/** The one shared header used by every web report. */
export default function ReportPageHeader({ title, subtitle, stats = [], actions }) {
  const navigate = useNavigate();
  return <Header>
    <TitleArea>
      <Eyebrow><FaChartBar /> Bill Sarthi Reports</Eyebrow>
      <h1>{title}</h1>
      {subtitle ? <p>{subtitle}</p> : null}
      {stats.length ? <Stats>{stats.map((stat) => <Stat key={stat.label}><small>{stat.label}</small><strong>{stat.value}</strong></Stat>)}</Stats> : null}
    </TitleArea>
    <Actions>
      <BackButton type="button" onClick={() => navigate("/reports")}>
        <FaArrowLeft /> Back to Reports
      </BackButton>
      {actions}
    </Actions>
  </Header>;
}

const Header=styled.section`
  display:flex;justify-content:space-between;align-items:flex-start;gap:22px;flex-wrap:wrap;
  margin-bottom:16px;padding:26px 28px;border-radius:22px;color:#fff;
  background:linear-gradient(135deg,var(--app-primary) 0%,var(--app-primary-hover) 62%,var(--app-primary-hover) 100%);
  box-shadow:0 14px 30px rgba(var(--app-primary-rgb), .17);
  @media(max-width:650px){padding:22px 18px;gap:16px;}
`;
const TitleArea=styled.div`min-width:0;h1{margin:5px 0 6px;font-size:clamp(1.45rem,2.4vw,2rem);line-height:1.15}p{margin:0;color:#dff3ff;line-height:1.45}`;
const Eyebrow=styled.div`display:inline-flex;align-items:center;gap:7px;color:#beeaff;font-size:.7rem;font-weight:900;letter-spacing:.1em;text-transform:uppercase`;
const Stats=styled.div`display:flex;gap:8px;flex-wrap:wrap;margin-top:15px`;
const Stat=styled.div`min-width:74px;padding:8px 11px;border:1px solid rgba(255,255,255,.24);border-radius:11px;background:rgba(255,255,255,.14);small,strong{display:block}small{color:#d7f1ff;font-size:.66rem;font-weight:700}strong{margin-top:2px;font-size:.91rem}`;
const Actions=styled.div`display:flex;align-items:center;justify-content:flex-end;gap:8px;flex-wrap:wrap;@media(max-width:650px){width:100%;justify-content:flex-start;}`;
const BackButton=styled.button`
  display:inline-flex;align-items:center;gap:7px;padding:9px 13px;border-radius:10px;
  border:1px solid rgba(255,255,255,.34);background:rgba(255,255,255,.16);
  color:#fff;font:inherit;font-size:.82rem;font-weight:800;cursor:pointer;
  transition:background .16s ease,transform .16s ease;
  &:hover{background:rgba(255,255,255,.26);transform:translateY(-1px)}
  &:focus-visible{outline:2px solid #fff;outline-offset:2px}
`;
